export const USER_EVENT_TYPES = {
    FILTER_CALENDAR: 'FILTER_CALENDAR',
    FILTER_COMPANIES: 'FILTER_COMPANIES',
    FILTER_ISSUES: 'FILTER_ISSUES',
    FILTER_WARRANTS: 'FILTER_WARRANTS',
    SEARCH: 'SEARCH',
    SHOW_ALL_ISSUES: 'SHOW_ALL_ISSUES',
    SHOW_ISSUE: 'SHOW_ISSUE',
    SHOW_INSTRUMENT_CUSTOM_TRADES_STATS: 'SHOW_INSTRUMENT_CUSTOM_TRADES_STATS',
    SHOW_INSTRUMENT_CUSTOM_TRADES_STATS_ERR_MAX_NUMBER_OF_DAYS:
        'SHOW_INSTRUMENT_CUSTOM_TRADES_STATS_ERR_MAX_NUMBER_OF_DAYS',
    SHOW_ALL_WARRANTS: 'SHOW_ALL_WARRANTS',
    SHOW_WARRANT: 'SHOW_WARRANT',
    SHOW_ALL_CONVERTIBLES: 'SHOW_ALL_CONVERTIBLES',
    SHOW_CONVERTIBLE: 'SHOW_CONVERTIBLE',
    SHOW_PRESS_RELEASE: 'SHOW_PRESS_RELEASE',
    SHOW_ALL_COMPANIES: 'SHOW_ALL_COMPANIES',
    SHOW_COMPANY: 'SHOW_COMPANY',
    SHOW_ALL_INVESTORS: 'SHOW_ALL_INVESTORS',
    SHOW_INVESTOR: 'SHOW_INVESTOR',
    SHOW_ALL_NEWS: 'SHOW_ALL_NEWS',
    SHOW_ALL_USERS: 'SHOW_ALL_USERS',
    SHOW_STATS_TREND_GRAPHS: 'SHOW_STATS_TREND_GRAPHS',
    SHOW_STATS_SCATTER_PLOT: 'SHOW_STATS_SCATTER_PLOT',
    SHOW_STATS_ISSUE_MARKET: 'SHOW_STATS_ISSUE_MARKET',
    SHOW_STATS_ADVISORS: 'SHOW_STATS_ADVISORS',
    STATS_TREND_GRAPHS_SELECTION: 'STATS_TREND_GRAPHS_SELECTION',
    STATS_SCATTER_PLOT_SELECTION: 'STATS_SCATTER_PLOT_SELECTION',
    STATS_ISSUE_MARKET_SELECTION: 'STATS_ISSUE_MARKET_SELECTION',
    STATS_ADVISORS_SELECTION: 'STATS_ADVISORS_SELECTION',
    ADMIN_CREATE_ISSUE: 'ADMIN_CREATE_ISSUE',
    ADMIN_EDIT_ISSUE: 'ADMIN_EDIT_ISSUE',
    ADMIN_DELETE_ISSUE: 'ADMIN_DELETE_ISSUE',
    ADMIN_EDIT_INSTRUMENT: 'ADMIN_EDIT_INSTRUMENT',
    ADMIN_CREATE_WARRANT: 'ADMIN_CREATE_WARRANT',
    ADMIN_EDIT_WARRANT: 'ADMIN_EDIT_WARRANT',
    ADMIN_DELETE_WARRANT: 'ADMIN_DELETE_WARRANT',
    ADMIN_CREATE_CONVERTIBLE: 'ADMIN_CREATE_CONVERTIBLE',
    ADMIN_EDIT_CONVERTIBLE: 'ADMIN_EDIT_CONVERTIBLE',
    ADMIN_DELETE_CONVERTIBLE: 'ADMIN_DELETE_CONVERTIBLE',
    LOGIN: 'LOGIN',
    SHOW_WATCH_LIST: 'SHOW_WATCH_LIST',
    ADD_WATCH_LIST_ITEM: 'ADD_WATCH_LIST_ITEM',
    DELETE_WATCH_LIST_ITEM: 'DELETE_WATCH_LIST_ITEM',
} as const

export type UserEventType = keyof typeof USER_EVENT_TYPES
